<template>
  <el-contain>
    <div style="width: 500px">
      <span style="color: white;">1.该功能为教育部服务器更新报告以及数据使用（上传jar、 sql备份等文件）, jar包上传地址：/mnt/storage/app/springboot</span>
      <el-upload
        style="margin-top: 20px"
        class="upload-demo"
        :data="additionalData"
        :action="uploadFileReq"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :before-remove="beforeRemove"
        :headers="headerToken"
        multiple
        :limit="5"
        :on-exceed="handleExceed"
        :file-list="fileList">
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>
      <div style="margin-top: 20px">
        <span style="color: white;">上传路径：</span><el-input v-model="uploadDirValue"></el-input>
      </div>

      <span style="color: white;">2.上传前端文件，更新教育部服务器</span>
      <el-upload
        style="margin-top: 20px"
        :action="uploadFrontFileReq"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :before-remove="beforeRemove"
        :headers="headerToken"
        :limit="5"
        :on-exceed="handleExceed"
        :file-list="frontFileList">
        <el-button size="small" type="primary">点击上传前端压缩包</el-button>
      </el-upload>
    </div>
  </el-contain>
</template>

<script>
  export default {
    data() {
      return {
        headerToken:{"lrmv2token":sessionStorage.getItem('lrmv2token') },
        uploadFileReq:'/lrmv2api/Lrmv2ToolsController/updateFileTo',
        uploadFrontFileReq: '/lrmv2api/Lrmv2ToolsController/uploadZipFile',
        fileList: [],
        frontFileList:[],
        uploadDirValue: 'D:/',
      };
    },
    created() {
    },
    computed: {
      additionalData() {
        return {
          uploadDir: this.uploadDirValue,
        };
      }
    },
    methods: {
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      }
    },
  };
</script>

<style scoped>

</style>
